module.exports = __webpack_public_path__ + "static/media/map-legend.a54e004f.png";